import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { memo } from 'react';
import PropTypes from 'prop-types';
import useChartUpdate from '../UseChartUpdate';
var Legend = /*#__PURE__*/memo(function (_ref) {
  var _ref$children = _ref.children,
      children = _ref$children === void 0 ? null : _ref$children,
      _ref$enabled = _ref.enabled,
      enabled = _ref$enabled === void 0 ? true : _ref$enabled,
      restProps = _objectWithoutProperties(_ref, ["children", "enabled"]);

  useChartUpdate(_objectSpread({
    enabled: enabled
  }, restProps), updateLegend, function (chart) {
    return updateLegend(chart, {
      enabled: false
    });
  }, false);
  return children;
});

var updateLegend = function updateLegend(chart, config) {
  chart.update({
    legend: config
  }, false);
};

Legend.propTypes = {
  enabled: PropTypes.bool
};
Legend.displayName = 'Legend';
export default Legend;